import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import profile from "@/data/profile";
import { trackOutbound } from "@/analytics/ga4";
import { useStartInquiry } from "@/lib/useInquiry";
import Reveal from "@/components/site/Reveal";

/**
 * CtaBand — the homepage's signature closing moment. Content sits directly on
 * a deep cinematic (ink) surface (no card box, per Impeccable), lit by a large
 * ambient accent bloom. Oversized statement + luminous primary CTA.
 */
export const CtaBand = () => {
    const start = useStartInquiry("cta_band");
    return (
        <section
            className="pg-section pg-surface-ink relative overflow-hidden"
            data-testid="home-cta-band"
            aria-label="Start a project"
            style={{ paddingTop: "clamp(5rem,9vw,8rem)", paddingBottom: "clamp(5rem,9vw,8rem)" }}
        >
            <span className="pg-accent-bloom pg-ambient-drift" aria-hidden style={{ right: "-6%", top: "-10%", width: "42vw", height: "42vw", maxWidth: "560px", maxHeight: "560px" }} />
            <div className="pg-container relative">
                <Reveal className="max-w-4xl">
                    <span className="pg-eyebrow">Let&rsquo;s Build</span>
                    <h2 className="pg-h1-page mt-6" style={{ color: "var(--pg-fg)" }}>
                        Ready to look <span className="pg-text-gold-static">unmistakable</span>?
                    </h2>
                    <p className="pg-lede mt-6 max-w-xl">
                        Share a short brief and we&rsquo;ll shape the right engagement, from a focused logo system to a full brand ecosystem.
                    </p>
                    <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
                        <button type="button" onClick={start} data-testid="home-cta-start" className="pg-btn-primary">
                            Start A Project
                            <ArrowUpRight className="h-4 w-4" strokeWidth={1.6} />
                        </button>
                        <a
                            href={profile.socials.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => trackOutbound("whatsapp")}
                            data-testid="home-cta-whatsapp"
                            className="pg-btn-ghost"
                        >
                            <MessageCircle className="h-4 w-4" strokeWidth={1.6} />
                            Talk on WhatsApp
                        </a>
                        <Link to="/contact" data-testid="home-cta-contact" className="pg-link-underline text-sm sm:ml-2" style={{ color: "var(--pg-fg-muted)" }}>
                            All contact options
                        </Link>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default CtaBand;
